<template>
  <button
    @click="takeNotes"
    title="Take notes" v-tippy
    :class="$style.container"><font-awesome-icon :icon="faPenAlt" /></button>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faPenAlt } from '@fortawesome/pro-light-svg-icons/faPenAlt'

export default {
  components: {
    FontAwesomeIcon
  },
  props: [
    'activity'
  ],
  data () {
    return {
      faPenAlt
    }
  },
  methods: {
    takeNotes () {
      this.$router.push({
        path: `/meetings/${this.activity.id}`,
        query: { tab: 'notepad' }
      })
    }
  }
}
</script>

<style module>
.container {
  font-size: 23px;
}
</style>



// WEBPACK FOOTER //
// TakeNotesButton.vue?a3cae0a2